import React from "react";
import ProposalFormContainer from "./ProposalFormContainer";

/**
 * Life Insurance Proposal Form
 * 
 * This is the main entry point for the 9-step proposal form.
 * The form uses a reusable component structure that separates:
 * - Layout (header, stepper, footer)
 * - Step components (individual form steps)
 * - State management (form validation and navigation)
 * 
 * Ready for API integration - all form submission logic is centralized
 * in ProposalFormContainer and can be easily replaced with API calls.
 */
const ProposalPolicyForm: React.FC = () => {
  return <ProposalFormContainer />;
};

export default ProposalPolicyForm;
